import React, { useEffect, useState } from "react";
import BuilderTabs from "../../Layouts/BuilderTabs";
import SelectSubfields from "../../Pages/Form/EditFieldAttribute/SelectSubfields";
import { groupByKey } from "../../commonFunctions/arrayFunc";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { useTableContext } from "../../context/TableContext";
import { useTreeContext } from "../../context/TreeDataContext";
import BasicStyleEditor from "../BuilderComponents/BasicStyleEditor";
import { VariableMapping } from "../BuilderComponents/JobConfigration/GetVariableMapping";
import { NewPrefilter } from "../BuilderComponents/PreFilters/PreFilter";
import Button from "../FormComponents/Button";
import Input from "../FormComponents/Input";
import SingleSelectBox from "../FormComponents/SingleSelectBox";
import { EditLabelWithIcon } from "./EditLabel";

const EditDropdownNavigate = ({ editElementData, setEditElementData, device }) => {
  const updateClassAndInlineStyle = (data) => {
    setEditElementData({ ...editElementData, className: data.classData, inline_style: data.inlineData });
  };

  return (
    <div>
      <BuilderTabs
        tabs={[
          {
            label: "Configuration",
            content: (
              <DropdownNavigateConfiguration
                editElementData={editElementData}
                setEditElementData={setEditElementData}
                device={device}
              />
            )
          },
          {
            label: "Styles",
            content: (
              <div style={{ width: "384px" }}>
                <DropdownNavigateStyles editElementData={editElementData} setEditElementData={setEditElementData} />
                <div className="form_basic_field_wrapper sidebar-edit-option-outer" style={{ paddingTop: "0px" }}>
                  <BasicStyleEditor
                    value={{
                      classData: editElementData?.className || {},
                      inlineData: editElementData?.inline_style || {}
                    }}
                    callbackFunction={updateClassAndInlineStyle}
                    fieldType={editElementData?.type || ""}
                  />
                </div>
              </div>
            )
          },
          {
            label: "Prefilters",
            content: (
              <DropdownNavigatePrefilters editElementData={editElementData} setEditElementData={setEditElementData} />
            )
          }
        ]}
      />
    </div>
  );
};

const DropdownNavigateStyles = ({ editElementData, setEditElementData }) => {
  const handleChange = (key, data) => {
    const copy = { ...editElementData };
    copy[key] = data;
    setEditElementData(copy);
  };
  // const handleButtonClassName = (heading, selectedValue) => {
  //   let updatedConfig = { ...editElementData };

  //   if (!updatedConfig.button) {
  //     updatedConfig.button = {};
  //   }

  //   updatedConfig.button.className = {
  //     ...updatedConfig.button.className,
  //     [heading]: selectedValue
  //   };

  //   setEditElementData(updatedConfig);
  // };

  return (
    <div className="builder_form p_3">
      <Input
        value={editElementData.name}
        label="Dropdown Label"
        onChange={(e) => handleChange("name", e.target.value)}
        placeholder="Enter a label"
      />
      <ButtonConfig config={editElementData.button} onChange={(buttonConf) => handleChange("button", buttonConf)} />
      {/* <ClassNameSelector
        value={editElementData.button?.className || {}}
        onChange={handleButtonClassName}
        type="button"
      /> */}
    </div>
  );
};

const ButtonConfig = ({ config, onChange }) => {
  const handleChange = (key, data) => {
    const copy = { ...config };
    copy[key] = data;
    onChange(copy);
  };

  return (
    <div>
      <EditLabelWithIcon
        label="Button Label"
        icon={config.icon}
        onIconChange={(icon) => handleChange("icon", icon)}
        name={config.name}
        onNameChange={(name) => handleChange("name", name)}
        placeholder="Enter Label Name"
      />
    </div>
  );
};

const DropdownNavigatePrefilters = ({ editElementData, setEditElementData }) => {
  if (!editElementData?.data_id || !editElementData?.data_type) {
    return <div>Both table ID and table type are required.</div>;
  }

  const handleChangePrefilter = (data) => {
    const copyElementData = { ...editElementData };
    copyElementData.prefilter = data.prefilter;
    copyElementData.prefilters_joined_by = data.prefilters_joined_by;
    setEditElementData(copyElementData);
  };

  return (
    <div className="p_3">
      <NewPrefilter
        prefiltersWithFormula={{
          prefilter: editElementData.prefilter || [],
          prefilters_joined_by: editElementData.prefilters_joined_by || ""
        }}
        handleChange={handleChangePrefilter}
        tableId={editElementData.data_id}
        tableType={editElementData.data_type}
      />
    </div>
  );
};

const DropdownNavigateConfiguration = ({ editElementData, setEditElementData, device }) => {
  const dropdownType = [
    {
      id: "entity",
      name: "Entity"
    },
    {
      id: "statemachine",
      name: "State Machine"
    }
  ];
  const handleChange = (key, data) => {
    const copyData = { ...editElementData };

    if ((key === "data_type" && data === "") || (key === "data_id" && data === "")) {
      copyData.display_fields = [];
      copyData.mapping = [];
      copyData.prefilter = [];
      copyData.prefilters_joined_by = "";

      if (key === "data_type") {
        copyData.data_id = "";
      }
    }

    copyData[key] = data;
    setEditElementData(copyData);
  };

  return (
    <div className="builder_form p_3">
      <NavigateScreenOptions
        selectedId={editElementData.page}
        onChange={(screen) => {
          handleChange("page", screen.name);
        }}
        device={device}
      />
      <SingleSelectBox
        selectedData={editElementData.data_type}
        options={dropdownType}
        onChange={(obj) => handleChange("data_type", obj.id)}
        placeholder="Select Type..."
        label={`Select Type`}
        error={""}
      />
      <DropdownTypeOptions
        dataType={editElementData.data_type}
        selectedId={editElementData.data_id}
        onChange={(data) => handleChange("data_id", data.id)}
      />
      <SelectSubfields
        label="Display fields"
        value={editElementData.display_fields || []}
        onChange={(newFields) => handleChange("display_fields", newFields)}
        tableId={editElementData.data_id}
        tableType={editElementData.data_type}
      />
      <VariableMappingOfDropdownNavigate
        tableId={editElementData.data_id}
        tableType={editElementData.data_type}
        mapping={editElementData.mapping || []}
        onChange={(mapping) => handleChange("mapping", mapping)}
      />
    </div>
  );
};

const VariableMappingOfDropdownNavigate = ({ tableId, tableType, mapping, onChange }) => {
  const { getTableTypeData } = useTableContext();
  const [tableObj, setTableObj] = useState(null);

  const handleParamsData = (data) => {
    onChange([...data.navigate_variable_mapping]);
  };

  const addNavigateMapping = () => {
    const newMapping = [...mapping, { key: "", value: "", type: "mapped" }];
    onChange(newMapping);
  };

  useEffect(() => {
    if (!(tableId && tableType)) return;
    const fetchTable = async () => {
      let { tableObject } = await getTableTypeData(tableType, tableId);
      setTableObj(tableObject);
    };
    fetchTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableId, tableType]);
  if (!tableObj || !tableId || !tableType) return null;
  return (
    <div>
      <div className="d_flex justify_end">
        <Button onClick={addNavigateMapping} variant="secondary">
          + Add
        </Button>
      </div>
      <VariableMapping
        keyName={"navigate_variable_mapping"}
        params={{
          name: "",
          navigate_variable_mapping: mapping
        }}
        handleParamsData={handleParamsData}
        isReadOnly={false}
        smId={tableId}
        jobTemplateName={"navigate_with_mapped"}
        allFieldsObject={{ current: tableObj }}
      />
    </div>
  );
};

const NavigateScreenOptions = ({ selectedId, device, onChange }) => {
  const { screensExplorerData } = useTreeContext();
  const result = screensExplorerData.find((screens) => screens.id === device);
  const handleChangePage = (screen) => {
    onChange(screen);
  };

  return (
    <SingleSelectBox
      valueKey="name"
      selectedData={selectedId}
      options={result.items}
      onChange={(obj) => handleChangePage(obj)}
      placeholder="Select Screen..."
      label={`Navigate Screen`}
      error={""}
      isSearch={true}
    />
  );
};

const DropdownTypeOptions = ({ dataType, selectedId, onChange }) => {
  const [state, setState] = useState({ loading: false, error: null });
  const [optionsOfType, setOptionsOfType] = useState({});

  const fetchOptions = async (endpoint) => {
    setState({ loading: true, error: null });
    try {
      const { data } = await axiosInstance.get(endpoint);
      const { result, error } = groupByKey(data, "sm_type");
      if (error) return;
      setOptionsOfType({
        ...optionsOfType,
        entity: result.entity || [],
        statemachine: result.default || []
      });
    } catch (error) {
      setState({ loading: false, error: "Failed to load data." });
      handleApiError();
    } finally {
      setState({ loading: false, error: null });
    }
  };

  const handleChangeTypeId = (obj) => {
    onChange(obj);
  };

  useEffect(() => {
    if (!dataType) return;

    if ((dataType === "entity" || dataType === "statemachine") && !optionsOfType[dataType]) {
      fetchOptions(`/state-machines`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataType]);

  if (state.loading) return <div>Loading...</div>;
  if (state.error) return <div>{state.error}</div>;

  if (!optionsOfType || !dataType) return null;
  return (
    <div>
      <SingleSelectBox
        selectedData={selectedId}
        options={optionsOfType[dataType] || []}
        onChange={handleChangeTypeId}
        placeholder="Select Table..."
        label={`Select Table`}
        error={""}
      />
    </div>
  );
};

export default EditDropdownNavigate;
